"use client";
import { jsx } from "react/jsx-runtime";
import React, { Children, cloneElement, useEffect, useState } from "react";
import cx from "classnames";
const Choice = (props) => {
  const {
    preselectedIndex,
    prefix = "",
    subtle,
    size = "large",
    children,
    deselectable,
    className,
    onSelect,
    ...other
  } = props;
  const childrenArray = Children.toArray(children);
  const [selectedItem, setSelectedItem] = useState(
    preselectedIndex !== void 0 ? childrenArray[preselectedIndex].props.id : null
  );
  const onChoiceSelect = (id) => {
    const isSelected = selectedItem === id;
    const currentItem = isSelected && deselectable ? null : id;
    setSelectedItem(currentItem);
    return onSelect && onSelect(currentItem);
  };
  useEffect(() => {
    setSelectedItem(
      preselectedIndex !== void 0 ? childrenArray[preselectedIndex].props.id : null
    );
  }, [preselectedIndex]);
  const baseClass = `${prefix}choice`;
  const listClasses = cx(baseClass, `${baseClass}--${size}`, className);
  return /* @__PURE__ */ jsx("ul", { className: listClasses, ...other, children: childrenArray.map((child, i) => {
    if (!React.isValidElement(child)) {
      return null;
    }
    const key = child.key || i;
    const isSelected = selectedItem === child.props.id;
    return /* @__PURE__ */ jsx("li", { className: `${baseClass}__list-item`, children: cloneElement(child, {
      selected: isSelected,
      onClick: () => {
        onChoiceSelect(child.props.id);
        if (child.props.onClick) child.props.onClick(child.props.id);
      },
      subtle,
      size
    }) }, key);
  }) });
};
var Choice_default = Choice;
export {
  Choice,
  Choice_default as default
};
